<template>
  <div>
    <v-container class="problema__container">
      <title-ribbon
        :title="problema.NombreProblema ? problema.NombreProblema : '...'"
        :theme="'orange'"
      />
      <div
        v-if="charged"
        class="problema_container__main"
      >
        <v-row class="problema_row__img">
          <v-col>
            <v-img
              :src="
                `https://res.cloudinary.com/dkod5pdlc/image/upload/f_auto,q_auto/v${cldVersion}/terapiacl/problemas/${problema.Imagen}`
              "
              :lazy-src="`https://res.cloudinary.com/dkod5pdlc/image/upload/f_auto,q_1,w_230,e_blur:1000/v${cldVersion}/terapiacl/problemas/${problema.Imagen}`"
              :aspect-ratio="1200 / 400"
            />
          </v-col>
        </v-row>
        <splitter :color="2" />
        <v-row class="problema_row__somos">
          <v-col>
            <p v-html="problema.Descripcion" />
          </v-col>
        </v-row>
        <splitter-volver :theme="'orange'" />
      </div>
      <div
        v-else
        class="text-center"
      >
        <v-progress-circular
          :size="70"
          :width="7"
          color="warning"
          indeterminate
        />
      </div>
    </v-container>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  export default {
    name: 'Problema',
    components: {
      TitleRibbon: () => import('@/components/web/base/TitleRibbon'),
      Splitter: () => import('@/components/web/base/Splitter'),
      SplitterVolver: () => import('@/components/web/base/SplitterVolver'),
    },
    data () {
      return {
        problema: '',
        charged: false,
      }
    },
    computed: {
      ...mapState('web', ['cldVersion']),
    },
    created () {
      this.getProblema(this.$route.params.toLink)
    },
    methods: {
      getProblema (toLink) {
        this.charged = false
        this.problema = ''
        Vue.axios
          .post('/problemas/problema', { toLink })
          .then(response => {
            this.problema = response.data.problema[0]
            this.charged = true
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    metaInfo: {
      title: 'Problema',
      titleTemplate: '%s - Centro de Terapia del Comportamiento',
      htmlAttrs: {
        lang: 'es',
        amp: true,
      },
    },
  }
</script>
